@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  @include dropdown-shadow;
  @include hide-scrollbar;
  @include blur;
  border-radius: 6px;
  padding: 4px;
  min-width: 156px;
  overflow: scroll;
  background: var(--light-80);
  display: flex;
  flex-direction: column;

  [data-autopilot-system-redesign='on'] & {
    border-radius: 8px;
    border: 1px solid var(--dark-4);
    background: var(--light-100);
    box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.05);
  }
}

.backdrop {
  z-index: 400;
}
